/* Aurilia Rituals — theme.js · light vanilla interactions
   (slideshow, cart drawer, search, menu, accordions, gift finder, festive mode)
   Each behaviour is null-safe so sections can be added/removed freely. */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---- Hero slideshow ---- */
  function initHero() {
    $$(".hero[data-slideshow]").forEach(function (hero) {
      var slides = $$(".hero__slide", hero);
      if (slides.length < 2) return;
      var i = 0, delay = parseInt(hero.getAttribute("data-interval") || "5000", 10);
      setInterval(function () {
        slides[i].classList.remove("is-active");
        i = (i + 1) % slides.length;
        slides[i].classList.add("is-active");
      }, delay);
    });
  }

  /* ---- Category pill filter (client-side show/hide by data-cat) ---- */
  function initPills() {
    $$("[data-pill-group]").forEach(function (group) {
      var pills = $$(".pill", group);
      var grid = $("#" + group.getAttribute("data-target"));
      if (!grid) return;
      pills.forEach(function (pill) {
        pill.addEventListener("click", function () {
          pills.forEach(function (p) { p.classList.remove("is-on"); });
          pill.classList.add("is-on");
          var cat = pill.getAttribute("data-cat");
          $$(".pcard", grid).forEach(function (card) {
            var cats = (card.getAttribute("data-cats") || "").split(",");
            card.style.display = (cat === "all" || cats.indexOf(cat) > -1) ? "" : "none";
          });
        });
      });
    });
  }

  /* ---- Drawers (cart, menu) + scrims ---- */
  function openDrawer(id) { var d = $("#" + id); if (d) { d.classList.add("is-open"); $$(".scrim").forEach(function (s) { s.classList.add("is-open"); }); document.body.classList.add("drawer-lock"); } }
  function closeDrawers() { $$(".drawer.is-open,.scrim.is-open").forEach(function (e) { e.classList.remove("is-open"); }); document.body.classList.remove("drawer-lock"); }
  function initDrawers() {
    $$("[data-open-drawer]").forEach(function (b) { b.addEventListener("click", function (e) { e.preventDefault(); openDrawer(b.getAttribute("data-open-drawer")); }); });
    $$("[data-close-drawer]").forEach(function (b) { b.addEventListener("click", closeDrawers); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawers(); });
  }

  /* ---- Search overlay ---- */
  function initSearch() {
    $$("[data-open-search]").forEach(function (b) { b.addEventListener("click", function () { var s = $("#SearchOverlay"); if (s) { s.classList.add("is-open"); var inp = $("input", s); if (inp) inp.focus(); } }); });
    $$("[data-close-search]").forEach(function (b) { b.addEventListener("click", function () { var s = $("#SearchOverlay"); if (s) s.classList.remove("is-open"); }); });
  }

  /* ---- Accordions ---- */
  function initAccordions() {
    $$(".acc__head").forEach(function (head) {
      head.addEventListener("click", function () { head.closest(".acc").classList.toggle("is-open"); });
    });
  }

  /* ---- Festive (Diwali) toggle ---- */
  function initFestive() {
    $$("[data-festive-toggle]").forEach(function (b) {
      b.addEventListener("click", function () { document.documentElement.classList.toggle("festive"); });
    });
  }

  /* ---- Gift finder (occasion chips + budget → filter matches) ---- */
  function initGiftFinder() {
    var gf = $("#GiftFinder"); if (!gf) return;
    var chips = $$(".gf-occ", gf), range = $(".gf-range", gf), out = $(".gf-budget-val", gf), results = $(".gf-results", gf);
    var occasion = null;
    function render() {
      if (!results) return;
      var budget = range ? parseInt(range.value, 10) : 9999;
      $$(".gf-match", results).forEach(function (m) {
        var price = parseInt(m.getAttribute("data-price") || "0", 10);
        var occ = (m.getAttribute("data-occasions") || "").split(",");
        var ok = price <= budget && (!occasion || occ.indexOf(occasion) > -1);
        m.style.display = ok ? "" : "none";
      });
      results.classList.add("is-shown");
    }
    chips.forEach(function (c) { c.addEventListener("click", function () { chips.forEach(function (x) { x.classList.remove("is-on"); }); c.classList.add("is-on"); occasion = c.getAttribute("data-occasion"); render(); }); });
    if (range) range.addEventListener("input", function () { if (out) out.textContent = "₹" + parseInt(range.value, 10).toLocaleString("en-IN"); render(); });
  }

  /* ---- Personalisation live preview (PDP) ---- */
  function initPersonalise() {
    $$(".pers").forEach(function (pers) {
      var inputs = $$(".pers__input", pers), preview = $(".pers__preview-text", pers), wrap = $(".pers__preview", pers);
      function upd() {
        var a = inputs[0] ? inputs[0].value : "", b = inputs[1] ? inputs[1].value : "";
        var text = b ? (a || "—") + " & " + b : a;
        if (preview) preview.textContent = text || "";
        if (wrap) wrap.style.display = text ? "" : "none";
      }
      inputs.forEach(function (i) { i.addEventListener("input", upd); });
      upd();
    });
  }

  /* ---- Newsletter popup (session-dismissed) ---- */
  function initPopup() {
    var pop = $("#NewsPopup"); if (!pop) return;
    var dismissed = false; try { dismissed = sessionStorage.getItem("ar_news") === "1"; } catch (e) {}
    if (!dismissed) setTimeout(function () { pop.classList.add("is-open"); }, 6000);
    $$("[data-close-popup]", pop).forEach(function (b) { b.addEventListener("click", function () { pop.classList.remove("is-open"); try { sessionStorage.setItem("ar_news", "1"); } catch (e) {} }); });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initHero(); initPills(); initDrawers(); initSearch(); initAccordions();
    initFestive(); initGiftFinder(); initPersonalise(); initPopup();
  });
})();
